import { useState } from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { DownOutlined, UpOutlined, MessageOutlined } from '@ant-design/icons';
import { t } from '../../i18n/i18n';
import ManualActionSelector from '../ManualActionSelector/ManualActionSelector';
import DeleteIcon from '../../assets/profile/Delete';
import './ThreadComments.scss';

const ThreadComments = ({
  threadComments = [],
  onDelete,
  currentUserId,
  onReply,
  parentCommentId,
  parentComment,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!threadComments || threadComments.length === 0) {
    return null;
  }

  const renderFileLink = (file) => {
    if (!file) return null;

    return (
      <div className="thread-comment-file mt-2" data-testid="thread-comment-file">
        <a
          href={file.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-blue-principal"
          download={file.name}
        >
          {file.name}
        </a>
      </div>
    );
  };

  return (
    <div className="thread-comments-container" data-testid="thread-comments-container">
      <button
        type="button"
        className="thread-toggle-button"
        onClick={() => setIsExpanded(!isExpanded)}
        data-testid="thread-toggle-button"
      >
        {isExpanded ? <UpOutlined /> : <DownOutlined />}
        <span className="ml-2">
          {t('OPEN_THREAD_COMMENTS')} ({threadComments.length})
        </span>
      </button>

      {isExpanded && (
        <div className="thread-comments-list" data-testid="thread-comments-list">
          {threadComments.map((comment, index) => (
            <div
              key={comment.id}
              className="thread-comment-item"
              data-testid={`thread-comment-${index}`}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center gap-2">
                    <span className="font-weight-bold text-xs">
                      {comment.partnerName
                        ? comment.partnerName
                        : `${comment.authorName} ${comment.authorLastname}`}
                    </span>
                    <span className="text-xs text-muted">
                      ({format(new Date(comment.createdAt), 'dd/MM/yyyy', { locale: es })})
                    </span>

                    {comment.manualAction && (
                      <ManualActionSelector value={comment.manualAction} readOnly />
                    )}
                  </div>

                  <p className="text-xs mt-2 thread-comment-text">
                    {comment.text || comment.comment}
                  </p>

                  {renderFileLink(comment.file)}
                </div>

                <div className="d-flex align-items-center gap-2">
                  {/* Show reply button only on first or last comment */}
                  {index === threadComments.length - 1 && (
                    <button
                      type="button"
                      onClick={() =>
                        onReply(parentCommentId, [...threadComments.slice(0, index + 1)])
                      }
                      className="thread-reply-button-icon d-flex align-items-center outline-none"
                      title={t('REPLY_TO_COMMENT')}
                      data-testid={`thread-reply-button-${index}`}
                    >
                      <MessageOutlined style={{ color: '#4987be', fontSize: '14px' }} />
                    </button>
                  )}

                  {(currentUserId === comment.partnerId || currentUserId === comment.authorId) && (
                    <button
                      type="button"
                      onClick={() => onDelete(comment.id)}
                      className="thread-delete-button d-flex align-items-center outline-none"
                      data-testid={`thread-delete-button-${index}`}
                    >
                      <DeleteIcon fill="#4987be" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ThreadComments;
